<template>
  <div class="mx-12 my-2">
    <v-tabs v-model="currentTab">
      <v-tab
        v-for="tab in allTabs"
        :key="tab.key"
        :value="tab.key"
      >
        {{ tab.label }}
      </v-tab>
    </v-tabs>
    <div v-if="currentTab && currentTabComponent && currentTabKey">
      <component
        :is="currentTabComponent"
        :key="currentTabKey"
        v-bind="currentTabProps"
        @update="refreshAll"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useCatalogsStore } from '@/store/catalogs'
import { useClientTypeStore } from '@/store/clientTypes'

import CatalogTable from './CatalogTable.vue'
import ClientTypeList from './ClientTypeList.vue'

const catalogsStore = useCatalogsStore()
const clientTypeStore = useClientTypeStore()
const currentTab = ref('')

const refreshAll = async () => {
  await Promise.all([
    catalogsStore.fetchCatalogs(),
    clientTypeStore.fetchClientTypes({})
  ])
  if (!currentTab.value && allTabs.value.length > 0) {
    currentTab.value = allTabs.value[0].key
  }
}

onMounted(refreshAll)

const allTabs = computed(() => {
  // Catálogos dinámicos
  const catalogTabs = (catalogsStore.catalogs || []).map((cat: any) => ({
    key: 'catalog_' + cat.id,
    label: cat.name,
    type: 'catalog',
    catalogId: cat.id
  }))
  // Endpoints especiales
  const specialTabs = [
    { key: 'clientTypes', label: 'Tipos de Cliente', type: 'clientTypes' }
    // Aquí puedes agregar más endpoints si quieres
  ]
  return [...specialTabs,...catalogTabs]
})

const currentTabComponent = computed(() => {
  const tab = allTabs.value.find(t => t.key === currentTab.value)
  if (!tab) return null
  if (tab.type === 'catalog') return CatalogTable
  if (tab.type === 'clientTypes') return ClientTypeList
  return null
})

const currentTabProps = computed(() => {
  const tab = allTabs.value.find(t => t.key === currentTab.value) as any
  if (!tab) return {}
  if (tab.type === 'catalog') {
    return {
      catalog: catalogsStore.catalogs.find((c: any) => c.id === tab.catalogId) || tab
    }
  }
  return {}
})

const currentTabKey = computed(() => {
  const tab = allTabs.value.find(t => t.key === currentTab.value)
  return tab ? tab.key : ''
});
</script>
